import { Stack as o } from "@mui/material";
import { css as d, styled as t } from "./styled2.mjs";
import { SIDE_NAV_COLLAPSED_WIDTH as r, SIDE_NAV_LIST_SIZE as s } from "./constants28.mjs";
const a = d`
	padding-left: ${({ theme: n, $isExpanded: i }) => `${i ? `${n.spacing(2)}` : `${(r - s) / 2}px`}`};
	padding-right: ${({ theme: n, $isExpanded: i }) => `${i ? `${n.spacing(2)}` : `${(r - s) / 2}px`}`};

	transition: ${({ theme: n, $isExpanded: i }) => n.transitions.create(["padding-left", "padding-right"], {
  easing: n.transitions.easing.sharp,
  duration: i ? n.transitions.duration.enteringScreen : n.transitions.duration.leavingScreen
})};
`, l = t("div")`
	z-index: ${({ theme: n }) => n.zIndex.drawer};
	position: fixed;
	top: 0;
	bottom: 0;
	flex-grow: 0;
	flex-shrink: 0;
	width: ${({ $width: n }) => `${n}px`};
	transition: ${({ theme: n, $isExpanded: i }) => n.transitions.create("width", {
  easing: n.transitions.easing.sharp,
  duration: i ? n.transitions.duration.enteringScreen : n.transitions.duration.leavingScreen
})};
`, $ = t(o)`
	height: 100%;
	background-color: ${({ theme: n }) => n.palette.background.level3};
	transition: ${({ theme: n, $isExpanded: i }) => n.transitions.create("width", {
  easing: n.transitions.easing.sharp,
  duration: i ? n.transitions.duration.enteringScreen : n.transitions.duration.leavingScreen
})};
	box-shadow: ${({ theme: n, $isExpanded: i, $canCollapse: e }) => i && e ? n.tokens.shadow.xlarge : "none"};
	border-right: ${({ theme: n }) => `1px solid ${n.palette.grey[200]}`};
`, S = t(o)`
	flex-grow: 1;
	${a}

	overflow-x: hidden;
	overflow-y: auto;

	::-webkit-scrollbar {
		display: none;
	}
`, x = t(o)`
	position: relative;
	display: flex;
	flex-direction: row;
	height: 100%;
	transition: ${({ theme: n, $isExpanded: i }) => n.transitions.create("width", {
  easing: n.transitions.easing.sharp,
  duration: i ? n.transitions.duration.enteringScreen : n.transitions.duration.leavingScreen
})};
`, k = t(o)`
	flex-grow: 1;
	gap: 24px;
`, u = t("div")`
	position: sticky;
	top: 0;
	z-index: ${({ theme: n }) => n.zIndex.header};
	background-color: ${({ theme: n }) => n.palette.background.level3};
	padding-top: ${({ theme: n }) => n.spacing(2)};
	margin-bottom: ${({ theme: n }) => n.tokens.spacing[16]};

	${a}
`, f = t("div")`
	${a};
	margin-bottom: ${({ theme: n }) => n.tokens.spacing[16]};
`, b = t("div")`
	${a};
	padding-top: ${({ theme: n }) => n.tokens.spacing[16]};
	padding-bottom: ${({ theme: n }) => n.tokens.spacing[16]};
	background: linear-gradient(0deg, #fff 90.2%, rgba(255, 255, 255, 0) 98.28%);
`;
export {
  f as FabSlot,
  b as FooterSlot,
  u as HeaderSlot,
  $ as StackAside,
  k as StackInner,
  S as StackNav,
  x as StackPlaceholder,
  l as Wrapper
};
//# sourceMappingURL=styles114.mjs.map
